import { Color, Mesh, MeshStandardMaterial, Scene } from "three";
import { generateUUID } from "three/src/math/MathUtils.js";
import { CameraInterface, Engine } from "../../engine/Engine";
import { Point } from "../Point";
import { Wall } from "./Wall";
import { Register } from "../../class/ClassRegistry";

@Register("BlankWall")
export class BlankWall extends Wall {
  protected _isMeterVisible = false;
  constructor(start: Point, end: Point) {
    super(start, end);
    this._type = "BlankWall";
    this._name = "BlankWall_" + generateUUID();
    this._height = 0.001;
    this._thickness = 0.05;
    this._isVisible = true;
    this.raycastable = false;
    this.initializeMeter();
    this.initializeColors();
  }

  protected initializeColors(): void {
    this._color2d = new Color("white");
    this._color3d = new Color("white");
    this._edgeColor2d = new Color(0);
  }

  get visible() {
    return this._isVisible;
  }

  set visible(value) {
    this._isVisible = value;
  }

  private _visibility = false;
  set visibility(value: boolean) {
    let _isMeterVisible = false;
    //bad code
    if (Engine.activeEngine.activeCamera?.instance.type != "OrthographicCamera")
      _isMeterVisible = !value;
    else _isMeterVisible = value;

    if (this._visibility == value && this._isMeterVisible == _isMeterVisible)
      return;

    this._visibility = value;
    this._isMeterVisible = _isMeterVisible;
    this.isDirty = true;
  }

  private _renderMeter(scene?: Scene, camera?: CameraInterface) {
    if (this._normal) {
      this._meter.isDirty = true;
      this._meter.render(scene, camera);
      if (this._root) {
        this._root.add(this._meter.root);
      }
    }
  }

  render2d(scene?: Scene, camera?: CameraInterface): void {
    super.render2d(scene, camera);
    this._renderMeter();
    this._root!.visible = true;
    this._mesh2D.visible = false;
    this.showEdges = true;
    ((this._root as Mesh).material as MeshStandardMaterial).opacity = 1;
  }

  render3d(scene?: Scene, camera?: CameraInterface): void {
    super.render3d(scene, camera);
    this.showEdges = false;
    this.raycastable = false;
    this._root!.visible = false;
    if (this._isMeterVisible) this._renderMeter();
  }
}
